import { ProductFeatures } from 'common/src/types/enums/ProductFeatures.enum';

import useAuth from 'portal/src/auth/useAuth';
import forbiddenResponse from 'portal/src/navigation/responses/forbiddenResponse';

import DashboardViewer from './DashboardViewer';

export default function CustomDashboardPage(): React.ReactElement {
  const { featureChecker } = useAuth();

  if (!featureChecker.productFeatureEnabled(ProductFeatures.customDashboards)) {
    throw forbiddenResponse();
  }

  return <DashboardViewer />;
}
